import { useEffect, useRef, useContext } from "react" 

import { Avatar } from '@mui/material'
import SmartToy from '@mui/icons-material/SmartToy'

import { ReplayChatContext } from '../context/ReplayChatContext'

import defaultAvatar1 from "../../../icon/defaultAvatars/user.png"

import '../../workspace/css/workspace.scss'

const formatTime = (isoString) => {
  if (!isoString) return ""
  return new Date(isoString).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
}

export default function ReplayChatWindow() {
  
  const { 
    messages, 
    currentInput, 
    isAiProcessing,
    chatMeta 
  } = useContext(ReplayChatContext)

  const { currentUserId, currentUserName, aiId } = chatMeta

  const chatHistoryRef = useRef(null)

  // Auto-scroll to bottom when messages or typing changes
  useEffect(() => {
    if (chatHistoryRef.current) {
      chatHistoryRef.current.scrollTop = chatHistoryRef.current.scrollHeight
    }
  }, [messages, isAiProcessing, currentInput]) 

  return (
    <div className="ws-chat-container">
      <div className="ws-chat">
        {/* 1. Message History Display */}
        <div 
          className="ws-chat-history" 
          ref={chatHistoryRef}
          style={{
            flex: '1 1 0',
            minHeight: 0,
            overflowY: 'auto'
          }}
        >
          {messages.map((msg, index) => {
            const isOwner = msg.sender_id === currentUserId
            const isAI = msg.sender_id === aiId
            const avatarUrl = isAI ? null : defaultAvatar1
            const displayName = isAI ? "AI Assistant" : (currentUserName || "User")

            return (
              <div key={msg.id || index} className={`ws-message ${isOwner ? 'ws-owner' : ''}`}>
                <div className="ws-message-info">
                  {isAI ? (
                    <Avatar sx={{ bgcolor: '#1976d2', width: 26, height: 26 }}>
                      <SmartToy sx={{ fontSize: '1rem' }} />
                    </Avatar>
                  ) : (
                    <img src={avatarUrl} alt="user avatar" />
                  )}
                  <span className="ws-info-name">{displayName}</span>
                  <span className="ws-info-time">{formatTime(msg.timestamp)}</span>
                </div>
                <div className="ws-message-content-wrapper">
                  <div className="ws-message-content">
                    <pre style={{ whiteSpace: 'pre-wrap', fontFamily: 'inherit' }}>{msg.content}</pre>
                  </div>
                </div>
              </div>
            )
          })}

          {/* Thinking Indicator */}
          {isAiProcessing && (
             <div className="ws-message">
               <div className="ws-message-info">
                 <Avatar sx={{ bgcolor: '#1976d2', width: 26, height: 26 }}>
                    <SmartToy sx={{ fontSize: '1rem' }} />
                 </Avatar>
                 <span className="ws-info-name">AI Assistant</span>
               </div>
               <div className="ws-message-content-wrapper">
                 <div className="ws-message-content" style={{ 
                     color: '#888', 
                     fontStyle: 'italic',
                     marginTop: '28px' 
                 }}>
                   Thinking...
                 </div>
               </div>
             </div>
          )}
        </div>
        
        {/* 2. Read-Only Input Area */}
        <div className="ws-message-form">
          <textarea 
            className="ws-message-input"
            rows={1}
            value={currentInput} 
            readOnly={true}      
            style={{ cursor: 'default' }}
            placeholder={messages.length === 0 ? "No messages yet..." : ""}
          />
          
          <div className="ws-char-count">
            <span style={{ color: '#999' }}>
              {currentInput.length > 0 ? `${currentInput.length}/500` : ""}
            </span>
          </div>

          <button 
            type="button" // Change to button to prevent form submission
            className="ws-send-button"
            disabled={true} 
            style={{ opacity: 0.5, cursor: 'default' }}
          >
            Send
          </button>
        </div>
      </div>
    </div>
  )
}